import { TYPE_OF_ORDER_TITLES } from 'widgets/CaseManagement/TypeOfOrder/TypeOfOrder';

type ProxyEntry = {
    value: number;
    label: string;
    accessPolicy: number | null;
};

type InputData = {
    owners: Record<string, string>;
    proxies: {
        accessPolicy: number;
        proxyId: number;
        proxyName: string;
    }[];
};

export const formatOwnersAndProxies = (input: InputData, t): ProxyEntry[] => {
    const { owners, proxies } = input || { owners: {}, proxies: [] };

    const ownerEntries: ProxyEntry[] = Object?.entries(owners)?.map(
        ([id, name]) => ({
            value: parseInt(id, 10),
            label: `${name} (${t(
                'CaseManagementPage.Modal.PoAModal.AccountOwner',
            )})`,
            accessPolicy: null,
        }),
    );

    const proxyEntries: ProxyEntry[] = proxies
        ?.filter((p) => p?.accessPolicy === 3)
        ?.map((proxy) => ({
            value: proxy.proxyId,
            label: `${proxy.proxyName} (${t(
                'CaseManagementPage.Modal.PoAModal.PowerOfAttorney',
            )})`,
            accessPolicy: proxy?.accessPolicy,
        }));

    return proxyEntries?.length > 0 ? [...ownerEntries, ...proxyEntries] : [];
};

export const docRefIdForPlanDataChangeForm = '3b_Sale_ChangeData_AZP';

export const getTypeFilterOptions = (t) => [
    {
        label: t('clientDashboard.documents.allBusinessUnits'),
        value: 0,
    },
    {
        label: t(TYPE_OF_ORDER_TITLES?.[1]),
        value: 1,
    },
    {
        label: t(TYPE_OF_ORDER_TITLES?.[2]),
        value: 2,
    },
];

// TO-DO: Need to get confirmation about the status types and update accordingly
export const getStatusFilterOptions = (data, t) => {
    const options = [
        {
            label: t('clientDashboard.documents.allBusinessUnits'),
            value: 0,
        },
    ]?.concat(
        data?.map((dta) => ({
            label: dta?.status || '-',
            value: dta?.statusId,
        })),
    );

    return options?.filter(
        (item, index, self) => item && index === self?.findIndex((t) => t?.value === item?.value),
    );
};
